<template>
    <div id="AddressSelect">
        <mu-bottom-sheet :open.sync="openAddress" class="select_container">
            <mu-flex class="header" justify-content="between" align-items="center">
                <p>{{title}}</p>
                <mu-button flat color="primary" @click="selected" v-if="selectFinish">{{$t("common.ok2")}}</mu-button>
            </mu-flex>
            <mu-tabs :value.sync="activeTab" inverse color="primary" indicator-color="primary" text-color="rgba(0, 0, 0, .54)">
                <mu-tab v-for="(arrayItem, index) in tabList" :key="index" :class="activeTab > index || selectFinish ? 'selected_item':''">
                    {{arrayItem.name}}
                </mu-tab>
            </mu-tabs>
            <template v-for="(arrayItem, index) in tabList">
                <div v-if="activeTab == index" :key="index" class="bottom_sheet_content">
                    <mu-flex wrap="wrap">
                        <mu-button flat v-for="item in arrayItem.children" :key="item.guid" @click="selectItem(arrayItem.code, item)">{{item.name}}</mu-button>
                    </mu-flex>
                </div>
            </template>
        </mu-bottom-sheet>
    </div>
</template>
<script>
import * as API from "@/api/system/address"

export default {
    name: "AddressSelect",
    data() {
        return {
            openAddress: false,
            selectFinish: false,
            activeTab:0,
            tabList: [],
            provinceList: [],
            cityList: [],
            areaList: [],
            streetList: [],
            result: {}
        }
    },
    props: {
        title: String,
        selectDone: Function,
        layer: Number
    },
    mounted() {
        API.getProvince({}).then(res => {
            console.log(res);
            this.provinceList = res;
            this.tabList.push({
                code: 'province',
                name: '省份',
                children: this.provinceList
            });
        });
    },
    methods: {
        openSelector() {
            this.openAddress = true;
        },
        selectItem(code, item) {
            console.log(item);
            this.tabList[this.activeTab].name = item.name;
            this.result[code] = item;
            if (code == 'province' && this.layer > 1) {
                API.getCity(item).then(res => {
                    this.popAddressList(1);
                    this.cityList = res;
                    var nextItem = {
                        code: 'city',
                        name: '城市',
                        children: this.cityList
                    };
                    this.tabList.push(nextItem);
                });
            } 
            if (code == 'city'  && this.layer > 2) {
                API.getArea(item).then(res => {
                    this.popAddressList(2);
                    this.areaList = res;
                    var nextItem = {
                        code: 'area',
                        name: '区县',
                        children: this.areaList
                    };
                    this.tabList.push(nextItem);
                    
                });
            }
            if (code == 'area' && this.layer > 3) {
                API.getStreet(item).then(res => {
                    this.popAddressList(3);
                    this.streetList = res;
                    var nextItem = {
                        code: 'street',
                        name: '街道',
                        children: this.streetList
                    };
                    this.tabList.push(nextItem);
                });
            }
            if (this.activeTab < this.layer - 1) {
                this.selectFinish = false;
                this.activeTab ++;
            } else {
                this.selectFinish = true;
            }
        },
        selected() {
            this.selectDone(this.result);
            this.openAddress = false;
        },
        popAddressList(index) {
            var oriLength = this.tabList.length;
            if (index >= oriLength) {
                return;
            }
            for (var i = index; i < oriLength; i++) {
                this.tabList.pop();
            }
        }
    }
}
</script>
<style scoped>
.select_container {
    min-height: 345px;
    max-height: 55vh;
}
.select_container .header {
    background:#f1f3f5;
    padding:4px 8px;
    width:100%;
}
.bottom_sheet_content {
    padding:24px 36px;
    height: 240px;
    overflow: auto;
}
.selected_item {
    background:#4880FF;
    color:#fff;
}
</style>


// WEBPACK FOOTER //
// src/components/AddressSelect.vue